import axios from "axios";

export default () => {
    return axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL || "https://api-line.xopay.cash",
        headers: {
            "Content-Type": "application/json",
            "api-key": process.env.VUE_APP_API_KEY || "BE0FC395FB04C071C9B0DDA3C63EAE71CCD638A5291737354985AF56B5DE3C86014A6542C6BD944C8AC652074C6091A59AA540D561DAC5AA3EB0638699DA0256",
        },
    });
};
